/*
 Duplicate of event-service/src/graphql/resolvers/ticket/utils/constants.ts
 Note: it maps to booking providers IDs while event-service BookingProviders uses strings
 stampede-web BookingProviders !== event-service BookingProviders enum
 */

export const BookingProviders = {
  PROXY: 1,
  DIRECT: 2,
  TRACKING_ONLY: 3,
  CHARITY: 4,
  BALLOT: 5,
  EVENTRAC: 6,
  RUNSIGNUP: 7,
  CLUBTRAC: 8,
  UBIO_PROXY: 9,
};
